module.exports = __webpack_public_path__ + "d7368ea4de0382ad0af07ff40f7e9abd.svg";